import { memo } from "react";
import type { AbsencesCalendarCell } from "./use-absences-calendar";

/** Props Interface */
interface AbsencesCalendarHeaderQuarterItemProps {
	cell: AbsencesCalendarCell;
}

function AbsencesCalendarHeaderQuarterItemImpl({ cell }: AbsencesCalendarHeaderQuarterItemProps) {
	/** Render */
	return (
		<div className="v-stack w-full h-full flex-center gap-0 items-center *:text-xs">
			<p>KW {cell.cellMoment.format("WW")}</p>
		</div>
	);
}

export const AbsencesCalendarHeaderQuarterItem = memo(AbsencesCalendarHeaderQuarterItemImpl);
